
import {throttle} from "//test.dorelan.eu/cdn/shop/t/25/assets/theme.js?v=22307413235526625761789658815";

// Header padding fix
const header_element = document.querySelector('.header__wrapper');

function stickyHeaderSize() {
  const shouldBeSticky = window.scrollY > 30;
  const isSticky = header_element.classList.contains('dor-header-sticky');
  
  if (isSticky !== shouldBeSticky) {
    header_element.classList.toggle('dor-header-sticky', shouldBeSticky);
  }
}

const checkScrollPosition = throttle(stickyHeaderSize);
document.addEventListener('scroll', checkScrollPosition, {passive: true});